import * as React from "react";
import { Offer } from "./Cruise";
import * as style from "./Cruise.style";
import { Helmet } from "react-helmet";

const MimosaContent: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Bring your Bachelor or Bachelorette party out for a Morning Mimosa Cruise in Dewey Beach / Rehoboth Beach. Book Now!"
        />
        <title>Dewey Beach Bachelor and Bachelorette Party Boat Trip</title>
      </Helmet>
      <div className={style.subHeader}>How it goes:</div>
      <div className={style.details}>
        There are not a lot of things more relaxing than a morning on the water.
      </div>
      <div className={style.details}>
        Pick your boat and embrace the morning sun on our Mimosa Cruise! Sip on
        your beverage of choice - whether it's mimosas, coffee, or whatever
        floats your boat. Recline, let go, and absorb the breathtaking scenery
        of the Delaware shores and waterfront real estate. It's the perfect way
        to start your day at the beach!
      </div>
    </>
  );
};

const Mimosa: React.FC = () => {
  return (
    <Offer
      title="Morning Mimosa Cruise"
      description="2 Hours &bull; All Ages &bull; Private Group of Up to 13 People"
      imageUrl="/dewey-beach-bachelorette-party-booze-cruise.png"
      imageAlt="Dewey Beach Bachelorette Party Booze Cruise"
      children={<MimosaContent />}
    />
  );
};

Mimosa.displayName = "Mimosa";
export { Mimosa };
